import { Routes, Route, Link, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import Home from './pages/Home';
import GameDetail from './pages/GameDetail';
import Stats from './pages/Stats';
import Guestbook from './pages/Guestbook';
import Register from './pages/Register';
import Login from './pages/Login';
import About from './pages/About';
import BrowserCheck from './components/BrowserCheck';

function App() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  // 初始化时从localStorage获取用户信息
  useEffect(() => {
    const savedUser = localStorage.getItem('user');
    if (savedUser) {
      setUser(JSON.parse(savedUser));
    }

    // 监听登录事件，登录成功后自动更新状态
    const handleUserLogin = () => {
      const savedUser = localStorage.getItem('user');
      if (savedUser) {
        setUser(JSON.parse(savedUser));
      }
    };
    window.addEventListener('userLogin', handleUserLogin);
    
    // 清理监听
    return () => {
      window.removeEventListener('userLogin', handleUserLogin);
    };
  }, []);

  // 登出功能
  const handleLogout = () => {
    localStorage.removeItem('user');
    setUser(null);
    alert('已退出登录');
    navigate('/');
  };

  return (
    <BrowserCheck>
      <div className="min-h-screen">
        {/* 导航栏 */}
        <nav className="bg-white shadow-sm border-b border-gray-200">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <Link to="/" className="text-2xl font-bold text-go-black">
                🎯 围棋棋谱检索网
              </Link>
              <div className="flex items-center space-x-4">
                <Link to="/" className="text-blue-600 hover:text-blue-800 transition" title="支持新版浏览器">
                  新版
                </Link>
                <a href="https://clas.wqqp.cn" className="text-blue-600 hover:text-blue-800 transition" title="支持所有浏览器">
                  原版
                </a>
                <a href="/software/?from=modern" className="text-blue-600 hover:text-blue-800 transition" title="围棋打谱windows软件">
                  下载
                </a>
                <a href="/guestbook/" className="text-blue-600 hover:text-blue-800 transition" title="欢迎留言提出建议和问题">
                  留言
                </a>
                <Link to="/about" className="text-blue-600 hover:text-blue-800 transition" title="关于本站">
                  关于
                </Link>
                {user ? (
                  // 已登录状态：显示欢迎信息和登出按钮（单行显示）
                  <div className="flex flex-row items-center gap-2">
                    <span className="text-green-600 text-sm font-bold">{user.username}</span>
                    <button 
                      onClick={handleLogout}
                      className="text-green-600 hover:text-green-800 text-sm font-bold transition"
                    >
                      登出
                    </button>
                  </div>
                ) : (
                  // 未登录状态：只显示登录入口（登录页面内含注册链接）
                  <Link to="/login" className="text-gray-600 hover:text-go-black transition">
                    登录
                  </Link>
                )}
              </div>
            </div>
          </div>
        </nav>

        {/* 主要内容 */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/game/:id" element={<GameDetail />} />
          <Route path="/stats" element={<Stats />} />
          <Route path="/guestbook" element={<Guestbook />} />
          <Route path="/register" element={<Register />} />
          <Route path="/login" element={<Login />} />
          <Route path="/about" element={<About />} />
        </Routes>

        {/* 页脚 */}
        <footer className="bg-white border-t border-gray-200 mt-2">
          <div className="max-w-7xl mx-auto px-4 py-4 text-center text-gray-500 text-sm font-bold">
            围棋棋谱检索网-收录海量高水准棋谱
          </div>
        </footer>
      </div>
    </BrowserCheck>
  );
}

export default App;
